// Reducer for the Agency Fulfilment Call Bot store module (STSMPD-1323).

import { AGENCY_CALL_STATE_SET, AGENCY_CALL_STATE_CLEAR } from './action-types'
import { AgencyCallAction } from './actions'
import { CallAlertState, CallStatus } from './types'

export type AgencyCallStateEntry = {
  lastState: CallAlertState | null
  status: CallStatus
  callRequestId: string
}

export type AgencyCallState = {
  /** Keyed by allocation_id. */
  byAllocation: Record<number, AgencyCallStateEntry>
}

export const initialState: AgencyCallState = {
  byAllocation: {},
}

const reducer = (state: AgencyCallState = initialState, action: AgencyCallAction): AgencyCallState => {
  switch (action.type) {
    case AGENCY_CALL_STATE_SET: {
      const { allocationId, lastState, status, callRequestId } = action.payload
      return {
        ...state,
        byAllocation: {
          ...state.byAllocation,
          [allocationId]: { lastState, status, callRequestId },
        },
      }
    }
    case AGENCY_CALL_STATE_CLEAR: {
      const next = { ...state.byAllocation }
      delete next[action.allocationId]
      return { ...state, byAllocation: next }
    }
    default:
      return state
  }
}

export default reducer
